import React from 'react';

import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider, createHashRouter } from 'react-router';

import { setupStore } from './redux/store';
import routes from './utils/routes';

async function enableMocking(): Promise<ServiceWorkerRegistration | void> {
  if (!import.meta.env.DEV) {
    return;
  }

  const { worker } = await import('./mocks/browser');

  return worker.start({
    onUnhandledRequest: 'bypass',
  });
}

const router = createHashRouter(routes);

enableMocking().then(() => {
  ReactDOM.createRoot(document.getElementById('selvtest-app')!).render(
    <React.StrictMode>
      <Provider store={setupStore()}>
        <RouterProvider router={router} />
      </Provider>
    </React.StrictMode>
  );
});
